export interface IUser {
  userID: string;
  userName?: string;
  email?: string;
  phoneNumber?: string;
  phoneNumberConfirmed: boolean;
  emailConfirmed: boolean;
  lockoutEnabled: boolean;
  surname?: string;
  name?: string;
  roles?: string[];
  hospitalID?: string;
  hospitalName?: string;
  clinicID?: string;
  clinicName?: string;
}

export class User implements IUser {
  userID: string;
  userName?: string;
  email?: string;
  phoneNumber?: string;
  phoneNumberConfirmed: boolean;
  emailConfirmed: boolean;
  lockoutEnabled: boolean;
  surname?: string;
  name?: string;
  roles?: string[];
  hospitalID?: string;
  hospitalName?: string;
  clinicID?: string;
  clinicName?: string;

  constructor();
  constructor(obj: IUser);
  constructor(obj?: IUser) {
    this.userID = obj?.userID ?? '';
    this.userName = obj?.userName ?? '';
    this.email = obj?.email ?? '';
    this.phoneNumber = obj?.phoneNumber;
    this.phoneNumberConfirmed = obj?.phoneNumberConfirmed ?? false;
    this.emailConfirmed = obj?.emailConfirmed ?? false;
    this.lockoutEnabled = obj?.lockoutEnabled ?? false;
    this.surname = obj?.userName ?? '';
    this.name = obj?.name ?? '';
    this.roles = obj?.roles;
    this.hospitalID = obj?.hospitalID;
    this.hospitalName = obj?.hospitalName;
    this.clinicID = obj?.clinicID;
    this.clinicName = obj?.clinicName;
  }
}
